module.exports = __webpack_public_path__ + "static/media/16UNODC7.e8c401db.jpg";